// TopicOffset.js - Defines topic offset enumerations.

// HelpBot modules;
import Enum from './Enum';

const TOPIC_OFFSET = Enum(
   {
      INDEX        : 0,
      LEVEL        : 1,
      PARENT       : 2,
      FIRST_CHILD  : 3,
      IS_PARENT    : 3, // If it doesn't have a child then it isn't a parent;
      NEXT_SIBLING : 4,
      TEXT         : 5,
      INFO_ID      : 6,
      DETAILS      : 7,
   }
); // TOPIC_OFFSET;

export default TOPIC_OFFSET;
